export const SOME_CONST = 'SOME_CONST';

export const managerTypes = {
  ME: 'ME',
  OTHER: 'OTHER',
};

// ProjectType
export const testTypes = {
  WEB_APP_TEST: 'webapp',
  INFRASTRUCTURE_TEST: 'infrastructure',
  AUTOMATIC: 'automatic',
};

// ProjectConfigurationType
export const configuration = {
  EXTERNAL: 'external',
  INTERNAL: 'internal',
};

// ProjectTestingType
export const testBoxTypes = {
  BLACK_BOX: 'blackbox',
  GRAY_BOX: 'greybox',
};

export const testModeTypes = {
  AUTOMATED: 'automated',
  MANUAL: 'manual',
};

// ProjectStatus
export const projectStatuses = {
  SCOPING: 'scoping',
  PENDING: 'pending',
  IN_QUEUE: 'in-queue',
  DECLINED: 'declined',
  CANCELED: 'canceled',
  IN_PROGRESS: 'in-progress',
  REPEAT_IN_PROGRESS: 'repeat-in-progress',
  ON_HOLD: 'on-hold',
  FINISHED: 'finished',
  FAILED: 'failed',
};

export const automaticTestProjectType = 'automatic';

// ProjectBundle
export const projectBundles = {
  AUTOMATIC: 'automatic',
  MANUAL: 'manual',
  CYNERGY: 'cynergy',
};

export const emptyProject = Object.freeze({
  projectDetailsData: {
    manager: null,
    comment: null,
    name: null,
    testType: testTypes.WEB_APP_TEST,
    managerType: managerTypes.ME,
  },
  projectEnvironmentData: {
    configuration: {
      type: configuration.EXTERNAL,
      data: testBoxTypes.BLACK_BOX,
    },
    mode: testModeTypes.AUTOMATED,
  },
  projectResourcesData: {
    resources: [],
    resourcesScope: {},
  },
  projectBundlesData: {
    data: projectBundles.MANUAL,
  },
  projectProviderData: {
    startDate: null,
    endDate: null,
    projectDurationHours: 0,
    projectTotalPrice: 0,
    serviceProviderId: null,
    serviceProviderName: null,
  },
  projectReviewData: {
    data: null,
  },
  workData: {
    needToLoadWorkers: true,
  },
});

export const initNewProjectNavigation = {
  currentStep: 1,
  filledStepsCnt: 0,
  visitedStepsCnt: 1,
};

export const WORKING_HOURS_IN_DAY = 8;

export const RESOURCES_TYPES = {
  IP: 'ip',
  DOMAIN: 'domain',
};

export const ACTIONS_TYPES = {
  STOP: 'stop',
};

export const FEATURES_LIST = [
  'LoginLogout',
  'registration',
  'resetPassword',
  'sso',
  '2fa',
  'waf',
  'geoLocation',
  'certificatePinning',
  'payment',
  'chatBot',
  'couponProm',
  'bagCart',
  'profileSettings',
];

export const TASK_STATUSES = {
  active: 'active',
  finished: 'finished',
};

export const TEST_REPEAT_STATUS = {
  never: 'never',
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  annually: 'annually',
  weekday: 'weekday',
  custom: 'custom',
};

export const TEST_REPEAT_EVERY = {
  week: 'week',
  month: 'month',
};

export const TEST_TYPES_SUBDOMAINS = {
  vuln_infra: 'vuln_infra',
  hijack: 'hijack',
  waf: 'waf',
};
export const TEST_TYPES_HOSTS = {
  deepscan: 'deepscan',
  autoexplotation: 'autoexploitation',
};
export const TEST_TYPES_CLOUD_ASSETS = {
  vuln_infra: 'vuln_infra',
};
export const TEST_TYPES_TLDS = {
  discovery: 'discovery',
  employees: 'employees',
  dataleaks: 'dataleaks',
  sitemap: 'sitemap',
};
export const TEST_TYPES_ACCOUNTS = {
  cloud_discovery: 'cloud_discovery',
  cloud_compliance: 'cloud_compliance',
};
export const DATA_LEAKS_TYPES = {
  github: 'github',
  pastebin: 'pastebin',
  websites: 'websites',
  all: 'all',
};
export const ALL_TEST_CARD_TYPES = {
  ...TEST_TYPES_SUBDOMAINS,
  ...TEST_TYPES_HOSTS,
  ...TEST_TYPES_TLDS,
  dataleaksGithub: 'dataleaks_github',
  dataleaksPastebin: 'dataleaks_pastebin',
};
export const ACTIVE_TEST_CARD_TYPES = {
  autoexplotation: 'autoexploitation',
  deepscan: 'deepscan',
  vuln_infra: 'vuln_infra',
  vuln_web: 'vuln_web',
};
export const TEST_TYPES_INFO = {
  discovery: 'Maps external assets, IPs, services, ports, and vulnerabilities for organizational security',
  employees: 'Identifies employees\' emails, historical leaks, shadow IT, and profiles for security analysis',
  dataleaks: 'Identifies potential exposure of sensitive information on external assets of the organization and third-party entities',
  sitemap: 'Maps assets with Sitemap enabled, web pages, features, and visualizes data',
  cloud_discovery: 'Scans for cloud services, identifying exposed assets for enhanced security management',
  cloud_compliance: 'Performs compliance checks with major cloud providers for organizational security',
  deepscan: 'Scans all ports on assets, identifying services, versions, and related known common vulnerabilities',
  autoexploitation: 'Uses deep-scan data to validate discovered common vulnerabilities with existing exploits',
  vuln_infra: 'Actively scans selected assets to identify both infrastructure and applicative vulnerabilities and CVEs',
  hijack: 'Assesses assets for susceptibility to subdomain hijacking vulnerabilities',
  waf: 'Determines if assets are protected by WAF and identifies the WAF vendor or service',
  cloud_vuln_infra: 'Conducts active scans on selected assets to identify vulnerabilities in cloud infrastructure and applications',
  defaultTLD: 'Scans available for top level domain domains',
  defaultSubdomain: 'Scans available for inventory assets',
};
